<template>
  <BittsModal
    v-if="isVisible"
    container-class="c-sso-login-prompt"
    variant="confirm"
    :icon="['fas', 'right-to-bracket']"
    icon-color="info"
    title="Your team uses single sign-on"
    :description="description"
    primary-button-text="Continue with SSO"
    :secondary-button-text="secondaryButtonText"
    @action="handleContinueSso"
    @secondary-action="handleDismiss"
  />
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    organizationName: string;
    secondaryButtonText?: string;
  }>(),
  { secondaryButtonText: 'Continue with password' },
);

const emit = defineEmits<(event: 'continue-sso' | 'dismiss') => void>();

const isVisible = defineModel<boolean>('visible', { required: true });

const description = computed(
  () =>
    `${props.organizationName} has SSO enabled. We recommend signing in with SSO so you can be added to your team automatically.`,
);

function handleContinueSso() {
  isVisible.value = false;
  emit('continue-sso');
}

function handleDismiss() {
  isVisible.value = false;
  emit('dismiss');
}
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
:deep(.c-sso-login-prompt) {
  @apply !w-[480px];
}
</style>
